var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.5 20.5h-13a1 1 0 0 1 0-2h13a1 1 0 0 1 0 2z",
    fill: "#9c34c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.13 6.25a2 2 0 0 0 -2.24-.08l-2.42 1.4-2.76-4.15a2.06 2.06 0 0 0 -3.42 0l-2.83 4.16-2.36-1.41a2 2 0 0 0 -3.1 2.16l1.47 7.32a2 2 0 0 0 2 1.65h13a2 2 0 0 0 2-1.65l1.53-7.32a2 2 0 0 0 -.87-2.08z",
    fill: "#ffce29"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    fill: "#ffa500",
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.e5d8f2e54dae1ab57b365ee93be32c35.svg";
export { ForwardRef as ReactComponent };